import { Stack } from '@mui/material'
import { memo } from 'react'

import Text from '../shared/text/Text'
import { Image } from '../shared/image'

const HowItWorksItem = ({ title, desc, icon }) => {
  return (
    <Stack
      sx={{ alignItems: 'center', textAlign: 'center', width: 1 }}
      spacing={1}
    >
      <Image src={icon} sx={{ width: 120 }} />
      <Text
        label={title}
        color='inherit'
        variant='body1'
        sx={{ fontWeight: 'bold' }}
      />
      <Text variant='body2' label={desc} />
    </Stack>
  )
}

export default memo(HowItWorksItem)
